import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import zoom from "./function_zoom";
import getCssVarValue from "./function_get-css-var-value";

export default (function () {
    var selector = "[data-layout='panning-image']";

    gsap.registerPlugin(ScrollTrigger);

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_panning-image.js initialized", "green");

        var offset = getCssVarValue("--space-global") * 2;
        var delay = getCssVarValue("--duration-xl");

        $(selector).each(function () {
            var $instance = $(this);
            var $keyframes = $instance.find("[data-keyframe]");
            var $target = $instance.find("[data-target]");
            var $frame = $instance.find("figure");
            var $caption = $instance.find("figcaption");
            var $progress = $instance.find(".progress-bar");

            var isPortrait = $frame.height() > $frame.width();
            var scaleMultiplier = window.innerWidth / $frame.width();

            // scaleMultiplier = isPortrait ? scaleMultiplier * 0.5 : scaleMultiplier;

            $keyframes.each(function () {
                ScrollTrigger.create({
                    scroller: window,
                    trigger: $(this)[0],
                    start: "top top",
                    end: "bottom top",
                    onEnterBack: enterHandler,
                    onEnter: enterHandler,
                    // onLeave: leaveHandler,
                    // onLeaveBack: leaveHandler,
                    // markers: true,
                });
            });

            /*
            gsap.to($frame[0], {
                alpha: 1,
                scale: scaleMultiplier,
                ease: "sine.inOut",
                duration: getCssVarValue("--duration-xl") / 1000,
                scrollTrigger: {
                    scroller: window,
                    trigger: $instance.find(".pan-intro")[0],
                    start: "top top",
                    endTrigger: $instance.find(".pan-outro")[0],
                    end: "top top",
                    toggleActions: "play reverse play reverse",
                    onToggle: function () {
                        $caption.toggleClass("on");
                    },
                },
            });
            */

            ScrollTrigger.create({
                trigger: $instance.find(".pan-core")[0],
                start: "top top",
                end: "bottom bottom",
                toggleActions: "play reverse play reverse",
                onToggle: (self) => {
                    if (self.isActive) {
                        $caption.addClass("on -z-1");
                    } else {
                        setTimeout(() => {
                            $caption.removeClass("on -z-1");
                        }, delay);
                    }
                },
            });

            gsap.to($progress[0], {
                scaleX: 1,
                ease: "none",
                scrollTrigger: {
                    trigger: $instance.find(".pan-core")[0],
                    start: "top top",
                    end: "bottom bottom",
                    toggleActions: "play reverse play reverse",
                    scrub: 1,
                    onToggle: function (self) {
                        $progress.toggleClass("on");
                    },
                },
            });

            /*
                ScrollTrigger.create({
                    trigger: $instance.find(".pan-intro")[0],
                    start: "top top",
                    endTrigger: $instance.find(".pan-outro")[0],
                    end: "bottom bottom",
                    onToggle: function () {
                        $frame.toggleClass("inset-global alpha-0.6");
                    },
                    // onLeave: leaveHandler,
                    // onLeaveBack: leaveHandler,
                    // markers: true,
                });
                */

            function enterHandler(_self) {
                // if (!_self.isActive) return;

                var $keyframe = $(_self.trigger);
                var focus = $keyframe.data("focus");
                var scale = $keyframe.data("scale");

                scale = scale > 1 ? scale * scaleMultiplier : scale;

                zoom($target, focus, scale);
            }

            /*
            setTimeout(function () {
                var $el = $instance.find("[data-lazy]:not([data-lazy='loaded'])");
                var data = {
                    sizes: $el.data("sizes") || $el.attr("sizes"),
                    srcset: $el.data("srcset") || $el.attr("srcset"),
                    src: $el.data("src") || $el.attr("src"),
                };

                $el.attr({
                    sizes: data.sizes,
                    srcset: data.srcset,
                    src: data.src,
                }).removeAttr("data-sizes data-srcset data-src");
                $el.on("load", function () {
                    $el.attr("data-lazy", "loaded");
                });
            }, 5000);
            */
        });
    }

    $(document).ready(init);
})();
